<template>
  <v-container class="main-container">
    <v-row>
      <v-col cols="12">
        <v-card
          tile
          flat
          class="userBriefHistory pa-2 pa-lg-5"
          :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
        >
          
          <TopPerformedIb></TopPerformedIb>
          
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import TopPerformedIb from "@/components/TopPerformedIb/TopPerformedIb.vue";
export default {
  components: {
    TopPerformedIb,
  },
};
</script>
